// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2CO8n","calendarButtons":"ClockData_calendarButtons__1atfZ"};